exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".checkbox-container{display:flex;flex-wrap:wrap}.checkbox-label{display:flex;align-items:center;margin-right:20px;position:relative}.checkbox-label input[type=checkbox]{opacity:0;position:absolute}.checkmark{display:inline-block;width:30px;height:30px;border:2px solid #ccc;border-radius:5px;margin-right:10px;cursor:pointer}.checkbox-label:hover .checkmark{border-color:#aaa}.checkbox-label input[type=checkbox]:checked+.checkmark{border-color:#2196f3}.checkmark:after{content:\"\";position:absolute;top:50%;left:50%;width:10px;height:10px;border-bottom:2px solid transparent;border-right:2px solid transparent;border-top:2px solid #2196f3;border-left:2px solid #2196f3;transform:translate(-50%,-50%) rotate(45deg);opacity:0}.checkbox-label input[type=checkbox]:checked+.checkmark:after{opacity:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-559b614a","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/common/rejectInvTallyBill.vue
// module id = 1616
// module chunks = 0